import { FunctionalArea } from '@/pages/authentication/CreateDealspace';
import { PlayBook } from '@Config/playBook';
import {
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import {
  getAssets,
  getAssetsFunctionalAreas,
} from '@Store/feature/assetsSlice';
import { useAppSelector } from '@Store/hooks';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './WorkstreamSelect.scss';

const ITEM_HEIGHT = 25;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 140,
    },
  },
};

type WorkStreamSelectProps = {
  selectedId: string;
  style?: React.CSSProperties;
  onChange: (event: SelectChangeEvent<PlayBook>) => void;
};

const WorkStreamSelect = ({
  selectedId,
  onChange,
  style = { width: 200 },
}: WorkStreamSelectProps) => {
  const { playbooks } = useAppSelector(getAssets);
  const { pid } = useParams();
  const assetsFunctionalAreas = useAppSelector(getAssetsFunctionalAreas);

  const selectDefaultPlayBook = () => {
    if (pid) {
      return playbooks?.find(item => item.id === pid) || null;
    }
    return null;
  };
  const [selectedWorkstreamId, setSelectedWorkstreamId] =
    useState<PlayBook | null>(selectDefaultPlayBook());

  const handleWorkStreamChanged = (event: SelectChangeEvent<PlayBook>) => {
    setSelectedWorkstreamId(
      playbooks?.find(item => item.id === event.target.value) || null
    );
    onChange(event);
  };

  const playBookMenuItem = ({
    id = '',
    name,
    functionalAreaId,
  }: PlayBook): React.ReactNode => (
    <MenuItem value={id}>
      <div
        style={{
          backgroundColor:
            assetsFunctionalAreas?.find(({ id }) => id === functionalAreaId)
              ?.color || '#1a7d77',
        }}
        className="playbook-avatar"
      >
        {name[0]}
      </div>{' '}
      <div className="playbook-avatar-title">{name}</div>
    </MenuItem>
  );

  return (
    <FormControl sx={style}>
      <Select
        displayEmpty
        value={selectedWorkstreamId ?? ''}
        className="workstream-selectbox"
        input={<OutlinedInput />}
        renderValue={value => value && playBookMenuItem(value)}
        MenuProps={MenuProps}
        inputProps={{ 'aria-label': 'Without label' }}
        onChange={handleWorkStreamChanged}
      >
        {playbooks
          ?.filter(f => f.dealspaceId === selectedId)
          ?.map(playBookMenuItem)}
      </Select>
    </FormControl>
  );
};

export default WorkStreamSelect;
